import React from "react";
import "./GsoAwardsBand.css";

/**
 * GSO awards / recognition band.
 * Recreated from gaspineortho.com data-id="a2d4184" — Best of Georgia 2025
 * award badge for Orthopedic Surgery Practice.
 */
export default function GsoAwardsBand() {
  return (
    <section
      className="gso-awards-band section-padding"
      role="region"
      aria-label="Awards and recognition"
    >
      <div className="container">
        <h2 className="gso-awards-band__heading">Awards &amp; Recognition</h2>
        <ul className="gso-awards-band__list">
          <li className="gso-awards-band__item">
            <div className="gso-awards-band__frame">
              <img
                src="/assets/brand/gso/awards/boga-2025-best-web.webp"
                alt="Best of Georgia 2025 — Awarded for Orthopedic Surgery Practice"
                width="234"
                height="60"
                loading="lazy"
              />
            </div>
            <p className="gso-awards-band__caption">
              Best of Georgia 2025 — Awarded for Orthopedic Surgery Practice
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
}
